
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Copy } from "lucide-react";
import { useToast } from "@/hooks/use-toast";

interface FCMTokenDisplayProps {
  fcmToken: string;
  isLoading: boolean;
  onRefreshToken: () => Promise<void>;
}

const FCMTokenDisplay = ({ fcmToken, isLoading, onRefreshToken }: FCMTokenDisplayProps) => {
  const [showToken, setShowToken] = useState(false);
  const { toast } = useToast();

  const copyTokenToClipboard = () => {
    navigator.clipboard.writeText(fcmToken);
    toast({
      title: "Token copied to clipboard",
      description: "You can now use this token in the Firebase console",
    });
  };

  return (
    <div className="w-full sm:w-auto">
      <Button
        variant="outline"
        onClick={() => setShowToken(!showToken)}
        className="mb-2 w-full"
        disabled={isLoading}
      >
        {isLoading ? "Loading..." : showToken ? "Hide Token" : "Reveal FCM Token"}
      </Button>
      {showToken && (
        <div className="flex gap-2 items-center bg-muted p-2 rounded-md">
          <div className="text-xs overflow-auto max-w-[200px] sm:max-w-[300px] truncate">
            {fcmToken || "No token available"}
          </div>
          {fcmToken && (
            <Button size="sm" variant="ghost" onClick={copyTokenToClipboard}>
              <Copy className="h-4 w-4" />
            </Button>
          )}
        </div>
      )}
      {showToken && (
        <Button 
          size="sm" 
          variant="outline" 
          onClick={onRefreshToken}
          className="mt-2"
          disabled={isLoading}
        >
          Refresh Token
        </Button>
      )}
    </div>
  );
};

export default FCMTokenDisplay;
